/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { alpha, type Theme } from '@mui/material';
import type { CSSProperties } from 'react';

/**
 * Theme colours for react-toastify and the toast CSS (toast.css, notifications/toast.css),
 * set as CSS variables on the toast root so toasts follow the MUI theme in both modes.
 */
export const getToastThemeVars = (theme: Theme): CSSProperties => {
  const dark = theme.palette.mode === 'dark';
  return {
    '--toastify-color-info': theme.palette.primary.main,
    '--toastify-color-success': theme.palette.success.main,
    '--toastify-color-warning': theme.palette.warning.main,
    '--toastify-color-error': theme.palette.error.main,
    '--pa-toast-surface': alpha(theme.palette.background.paper, dark ? 0.94 : 0.97),
    '--pa-toast-border': dark ? alpha(theme.palette.common.white, 0.12) : theme.palette.divider,
    '--pa-toast-text': theme.palette.text.primary,
    '--pa-toast-text-secondary': theme.palette.text.secondary,
    '--pa-toast-hover': theme.palette.action.hover,
    '--pa-toast-shadow': dark
      ? '0 16px 40px rgba(0, 0, 0, 0.4)'
      : '0 16px 40px rgba(23, 49, 69, 0.16)',
  } as CSSProperties;
};
